export default {
  owner: `Attribué à`,
  attributeOwner: 'Attribuer à',
  deadline: 'Echéance',
  note: 'Note',
  alertmessage: 'Votre message',
  progression: `Etat d'avancement`
}
